import styled from 'styled-components';
import { getSearchInputStyles } from '../Search/Search.styles';
import { colors } from '../_styles/colors';
import { spacing } from '../_styles/spacing';
var inputHeight = 36;
export var StyledInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledInput",
  componentId: "core-12_15_0__sc-gpc39h-0"
})(["", " padding-right:", "px;"], getSearchInputStyles(), spacing.xxl);
export var StyledIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledIcon",
  componentId: "core-12_15_0__sc-gpc39h-1"
})(["align-items:center;color:", ";display:flex;height:", "px;justify-content:center;pointer-events:", ";position:absolute;right:0;top:0;width:", "px;"], function (p) {
  return p.disabled ? colors.gray70 : colors.gray45;
}, inputHeight, function (p) {
  return p.disabled ? 'none' : 'auto';
}, inputHeight);
export var StyledTypeahead = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTypeahead",
  componentId: "core-12_15_0__sc-gpc39h-2"
})(["position:relative;width:100%;"]);
//# sourceMappingURL=Typeahead.styles.js.map